import { createContext, useContext, useEffect, useState } from "react";
import API from "../api";

// Sorgente unica di verità per la visibilità Orion, condivisa fra App.js
// (Sidebar, route guard di /user/network-status/zones) e il pulsante che
// esegue davvero il toggle (hostsOnlineGrid.jsx, pagina Inventory) — senza
// questo, il toggle aggiornava solo lo stato locale del pulsante e le altre
// pagine restavano con il valore stantio fino a un reload completo.
const OrionContext = createContext({
  orionEnabled: true,
  setOrionEnabled: () => {},
});

export const useOrion = () => useContext(OrionContext);

export function OrionProvider({ children }) {
  const [orionEnabled, setOrionEnabled] = useState(true);

  useEffect(() => {
    API.getOrionVisibility()
      .then((res) => setOrionEnabled(res?.data?.visibility !== false))
      .catch((err) => {
        console.error('[OrionProvider] Failed to fetch orion visibility:', err);
        setOrionEnabled(false);
      });
  }, []);

  return (
    <OrionContext.Provider value={{ orionEnabled, setOrionEnabled }}>
      {children}
    </OrionContext.Provider>
  );
}
